import { Component, EventEmitter, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { navigationItems } from '../../../../constants/navigation';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../../shared/button/button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { PageNavigationService } from '../../../../services/page-navigation.service';
import { AutoOpenMenuComponent } from '../auto-open-menu/auto-open-menu.component';


@Component({
    selector: 'app-toolbar',
    imports: [MatIconModule, CommonModule, MatButtonModule, ButtonComponent, MatMenuModule, RouterModule, AutoOpenMenuComponent],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})

export class ToolbarComponent {

  @Output() openSideMenu = new EventEmitter();

  public navItems = navigationItems;

  constructor(private navigationService: PageNavigationService) {}

  public stopPropagation(event: Event) {
    event.stopPropagation(); 
  }

  public goToContactForm() {
    this.navigationService.scrollTo('contactUs', ['/home']);
  }

  public goToFreeTrial() {
    this.navigationService.scrollTo('suites', ['/relief-apps']);
  }

  public goTo(id: any) {
    this.navigationService.scrollTo(id, ['/home']);
  }
}
